
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as index8C0eElaTQ8NCfNt8azt1GdCcKmTUXGuWrQgw3HiRIx0Meta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/index.vue?macro=true";
import { default as _91slug_93DTbYEJIoP1E00eAzPMiJ5DUQ7QgFjISNl8_35JF6t4wMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/[slug].vue?macro=true";
import { default as indexP4aZtJ11Ib6oIrHVaZxdxYuO5vV3LD3IQnh0XlFu618Meta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/search/index.vue?macro=true";
import { default as productsLaOybaF2jUs8VUa7jTqU7aTn1_HvRXnxmetQMGmpxm4Meta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/search/products.vue?macro=true";
import { default as documents5kcMXP80R2lHOzO1_45IHS7f1j2pMTX1TU2acBy_4AWGIMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/search/documents.vue?macro=true";
import { default as search5NKCd5kTca2mPzb80B2nD9HmKY2t7_45XVdU4J8Y1CPH8Meta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/search.vue?macro=true";
import { default as _91slug_93za1OMBArDl9dZPdnppLYsmZglQupbaXUH107oAFYdLIMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/news/[slug].vue?macro=true";
import { default as indexx1PPTH3H92UbH13uDtsmMkP015ak8kS1qc7tgxYadCIMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/catalog/index.vue?macro=true";
import { default as _91slug_93MHrSHV3aug70Mg7Nq4JGyumFTsp5vw93l3ex74BvYbIMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/catalog/[slug].vue?macro=true";
import { default as _91slug_933JMxguFDkTYcXe_S_aQrDmRiYr2qgvIq0q7TGn573QkMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/product/[slug].vue?macro=true";
import { default as index9wxYAM61gyikKitinivdMHtMeqk8LDP0qbIyylfZfRYMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/documents/[slug]/index.vue?macro=true";
export default [
  {
    name: "index___en",
    path: "/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/index.vue")
  },
  {
    name: "index___uk",
    path: "/uk",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/index.vue")
  },
  {
    name: "slug___en",
    path: "/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/[slug].vue")
  },
  {
    name: "slug___ru",
    path: "/ru/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/[slug].vue")
  },
  {
    name: "slug___uk",
    path: "/uk/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/[slug].vue")
  },
  {
    name: "slug___pl",
    path: "/pl/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/[slug].vue")
  },
  {
    name: search5NKCd5kTca2mPzb80B2nD9HmKY2t7_45XVdU4J8Y1CPH8Meta?.name,
    path: "/search",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/search.vue"),
    children: [
  {
    name: "search___en",
    path: "",
    meta: indexP4aZtJ11Ib6oIrHVaZxdxYuO5vV3LD3IQnh0XlFu618Meta || {},
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/search/index.vue")
  },
  {
    name: "search-products___en",
    path: "products",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/search/products.vue")
  },
  {
    name: "search-documents___en",
    path: "documents",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/search/documents.vue")
  }
]
  },
  {
    name: search5NKCd5kTca2mPzb80B2nD9HmKY2t7_45XVdU4J8Y1CPH8Meta?.name,
    path: "/ru/search",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/search.vue"),
    children: [
  {
    name: "search___ru",
    path: "",
    meta: indexP4aZtJ11Ib6oIrHVaZxdxYuO5vV3LD3IQnh0XlFu618Meta || {},
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/search/index.vue")
  },
  {
    name: "search-products___ru",
    path: "products",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/search/products.vue")
  },
  {
    name: "search-documents___ru",
    path: "documents",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/search/documents.vue")
  }
]
  },
  {
    name: search5NKCd5kTca2mPzb80B2nD9HmKY2t7_45XVdU4J8Y1CPH8Meta?.name,
    path: "/uk/search",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/search.vue"),
    children: [
  {
    name: "search___uk",
    path: "",
    meta: indexP4aZtJ11Ib6oIrHVaZxdxYuO5vV3LD3IQnh0XlFu618Meta || {},
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/search/index.vue")
  },
  {
    name: "search-products___uk",
    path: "products",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/search/products.vue")
  },
  {
    name: "search-documents___uk",
    path: "documents",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/search/documents.vue")
  }
]
  },
  {
    name: search5NKCd5kTca2mPzb80B2nD9HmKY2t7_45XVdU4J8Y1CPH8Meta?.name,
    path: "/pl/search",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/search.vue"),
    children: [
  {
    name: "search___pl",
    path: "",
    meta: indexP4aZtJ11Ib6oIrHVaZxdxYuO5vV3LD3IQnh0XlFu618Meta || {},
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/search/index.vue")
  },
  {
    name: "search-products___pl",
    path: "products",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/search/products.vue")
  },
  {
    name: "search-documents___pl",
    path: "documents",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/search/documents.vue")
  }
]
  },
  {
    name: "news-slug___en",
    path: "/news/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/news/[slug].vue")
  },
  {
    name: "news-slug___ru",
    path: "/ru/news/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/news/[slug].vue")
  },
  {
    name: "news-slug___uk",
    path: "/uk/news/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/news/[slug].vue")
  },
  {
    name: "news-slug___pl",
    path: "/pl/news/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/news/[slug].vue")
  },
  {
    name: "catalog___en",
    path: "/catalog",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/catalog/index.vue")
  },
  {
    name: "catalog___ru",
    path: "/ru/catalog",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/catalog/index.vue")
  },
  {
    name: "catalog___uk",
    path: "/uk/catalog",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/catalog/index.vue")
  },
  {
    name: "catalog___pl",
    path: "/pl/catalog",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/catalog/index.vue")
  },
  {
    name: "catalog-slug___en",
    path: "/catalog/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/catalog/[slug].vue")
  },
  {
    name: "catalog-slug___ru",
    path: "/ru/catalog/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/catalog/[slug].vue")
  },
  {
    name: "catalog-slug___uk",
    path: "/uk/catalog/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/catalog/[slug].vue")
  },
  {
    name: "catalog-slug___pl",
    path: "/pl/catalog/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/catalog/[slug].vue")
  },
  {
    name: "product-slug___en",
    path: "/product/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/product/[slug].vue")
  },
  {
    name: "product-slug___ru",
    path: "/ru/product/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/product/[slug].vue")
  },
  {
    name: "product-slug___uk",
    path: "/uk/product/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/product/[slug].vue")
  },
  {
    name: "product-slug___pl",
    path: "/pl/product/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/product/[slug].vue")
  },
  {
    name: "documents-slug___en",
    path: "/documents/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/documents/[slug]/index.vue")
  },
  {
    name: "documents-slug___ru",
    path: "/ru/documents/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/documents/[slug]/index.vue")
  },
  {
    name: "documents-slug___uk",
    path: "/uk/documents/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/documents/[slug]/index.vue")
  },
  {
    name: "documents-slug___pl",
    path: "/pl/documents/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/pages/documents/[slug]/index.vue")
  }
]